import Backbone from 'backbone';

import ElementModel from '../models/ElementModel';

export default Backbone.Collection.extend({
    model: ElementModel,
    comparator: undefined
});



// WEBPACK FOOTER //
// ./plugins/large_image/web_client/collections/ElementCollection.js